var _defs, _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAgeProfile = function SvgAgeProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".age-profile_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.251,
    r: 2.25,
    className: "age-profile_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.5a3 3 0 0 0-3 3V19H19l.5 4.5h2L22 19h1.5v-2.5a3 3 0 0 0-3-3",
    className: "age-profile_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.251,
    r: 2.25,
    className: "age-profile_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.5a3 3 0 0 0-3 3V19H2l.5 4.5h2L5 19h1.5v-2.5a3 3 0 0 0-3-3",
    className: "age-profile_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.25,
    r: 2.75,
    className: "age-profile_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5a3.5 3.5 0 0 0-7 0v3h1.583l.417 5h3l.417-5H15.5ZM.5 6.5 11.537.613a1 1 0 0 1 .926 0L23.5 6.5",
    className: "age-profile_svg__a"
  })));
};
export { SvgAgeProfile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmZhbWlseS1ob21lPC90aXRsZT48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMjAuNSIgY3k9IjEwLjI1MSIgcj0iMi4yNSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMjAuNSwxMy41YTMsMywwLDAsMC0zLDNWMTlIMTlsLjUsNC41aDJMMjIsMTloMS41VjE2LjVBMywzLDAsMCwwLDIwLjUsMTMuNVoiLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iMy41IiBjeT0iMTAuMjUxIiByPSIyLjI1Ii8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zLjUsMTMuNWEzLDMsMCwwLDAtMywzVjE5SDJsLjUsNC41aDJMNSwxOUg2LjVWMTYuNUEzLDMsMCwwLDAsMy41LDEzLjVaIi8+PGNpcmNsZSBjbGFzcz0iYSIgY3g9IjEyIiBjeT0iOC4yNSIgcj0iMi43NSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTUuNSwxNS41YTMuNSwzLjUsMCwwLDAtNywwdjNoMS41ODNsLjQxNyw1aDNsLjQxNy01SDE1LjVaIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0uNSw2LjUsMTEuNTM3LjYxM2ExLDEsMCwwLDEsLjkyNiwwTDIzLjUsNi41Ii8+PC9zdmc+";